import { useSelector } from "react-redux";
import { getCurrentRoute, getRequiredPermission } from "@/utils/permission";
import { localData } from "@/services/helper";
import { localKeys, role } from "@/utils/constants";
import { AuthDataType } from "@/types/authTypes";
import { useExpiryContext } from "@/utils/expiryCheck";

export const usePermissions = () => {
  const masterRoutes = useSelector((state: any) => state.getRoutes.list);
  const accessibleRoutes = useSelector((state: any) => state.accessibleRoutes?.list?.routes);
  const auth = localData.get<AuthDataType>(localKeys.authData);
  const userRole = auth?.role;
  const userRoleId = auth?.roleId;
  const isGracePeriod = auth?.subscriptionStatus === "grace_period";
   const { triggerGracePeriodModal } = useExpiryContext();


  const hasPermission = (path: string, permission?: string) => {
    const currentRoute = getCurrentRoute(masterRoutes || [], path);
    const access = accessibleRoutes?.find((r: any) => r.route === currentRoute?._id);

    if (!currentRoute) return false;

    if (userRole === role.SUPER_ADMIN_ROLE) return true;
    if (currentRoute.allowedRoles?.length > 0) {
      const hasRoleAccess = currentRoute.allowedRoles.some(
        (allowedRole: any) =>
          allowedRole.role === userRole ||
          allowedRole.roleId === userRoleId
      );
      if (!hasRoleAccess) return false;
    }

    if (!access) return false;

    const required = permission ?? getRequiredPermission(path);
    return access.access.includes(required);
  };

  const getFirstAccessibleRoute = () => {
    if (!masterRoutes?.length || !accessibleRoutes?.length) {
      return null;
    }

    // const firstRoute = masterRoutes.find((route: any) => {
    //   const access = accessibleRoutes.find(
    //     (item: any) =>
    //       item.route === route._id && item.access.includes("view")
    //   );

    //   return !!access;
    // });
    const firstRoute = masterRoutes
      .filter((route: any) => route.extra?.includes("sidebar"))
      .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
      .find((route: any) => {
        const access = accessibleRoutes.find(
          (item: any) =>
            item.route === route._id && item.access.includes("view")
        );
        return !!access;
      });
    console.log("First Accessible Route:", firstRoute?.path);
    return firstRoute?.path ?? null;
  };

  const guardAction = (action: () => void) => {
    if (isGracePeriod) {
      triggerGracePeriodModal();
      return;
    }
    action();
  }

  return {
    hasPermission, getFirstAccessibleRoute, guardAction
  };
};